// 事件处理函数
// import eventHandler from '@/components/tools/extend/event.js'
export default {
  // 组件名， module 下的a组件， config.componentAcPrefix = ac 为 公用的业务组件
  name: 'ac-bar-color',
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          // 返回的真正数据
          dataList: [{
            name: '学术论文',
            value: 100
          }, {
            name: '期刊',
            value: 200
          }, {
            name: '报纸',
            value: 300
          }, {
            name: '图书',
            value: 220
          }, {
            name: '会议论文',
            value: 123
          }]
        }
      }
    }
  },
  data () {
    return {
      // 图表类型
      myEchart: null,
      // 图表配置项
      options: {
        grid: {
          top: '8%',
          right: '10%',
          bottom: '8%',
          left: '18%'
        },
        tooltip: {
          show: true
        },
        yAxis: {
          splitLine: { show: false },
          axisLabel: {
            interval: 0,
            fontFamily: 'MicrosoftYaHei',
            fontSize: 12,
            color: 'rgba(0,0,0,0.85)'
          },
          axisTick: { show: false },
          axisLine: { show: false }
        },
        xAxis: {
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: 'rgba(0,0,0,0.1)'
            }
          },
          axisLine: { show: false },
          axisLabel: { show: false }
        },
        series: {
          type: 'bar',
          barWidth: 30,
          barMinHeight: 10,
          label: {
            normal: {
              show: true,
              position: 'right',
              textStyle: {
                color: 'rgba(0,0,0,0.85)'
              }
            }
          },
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: '#237E91'
              },
              {
                offset: 1,
                color: '#8EB1A6'
              }
              ])
            }
          }
        }
      }
    }
  },
  // 创建元素
  mounted () {
    // this.init()
    window.addEventListener('resize', this.resizeHandler)
  },
  // 销毁
  destroyed () {
    // 销毁图表
    this.destroyedChart()
  },
  // 方法定义
  methods: {

    /**
         * @description 初始化的方法
         * @name init
         * @return {*} 无
         */
    init () {
      // 更新数据
      this.update(this.data.dataList)
    },

    /**
         * @description 刷新图表
         * @return {*} 无
         */
    refresh () {
      if (this.myEchart) {
        this.myEchart.resize()
      }
    },

    /**
         * @description 更新
         * @name update
         * @return {*} 无
         */
    update (data) {
      // 如果不存在echarts
      if (!this.myEchart) {
        // 图表对象
        this.myEchart = this.$echarts.init(this.$refs.jsEchart)
        // 绑定resize 事件
        this.bindResizeEvent()
      }
      // 更新数据
      this.updateData(data)
      // 清空图表
      this.myEchart.clear()
      // 生成图表
      this.myEchart.setOption(this.options)
    },

    /**
         * @description 更新数据
         * @name updateData
         * @param {object} data 参数
         * @return {*} 无
         */
    updateData (data) {
      // 对y轴数据进行赋值
      this.options.yAxis.data = data.map(item => {
        return item.name
      }).reverse()
      this.options.series.data = data.reverse()
    },

    /**
         * @description 事件处理函数
         * @name resizeHandler
         * @return {*} 无
         */
    resizeHandler () {
      if (this.myEchart) {
        this.myEchart.resize()
      }
    },

    /**
         * @description 绑定resize 事件
         * @name init
         * @return {*} 无
         */
    bindResizeEvent () {
      // 绑定resize事件
      // eventHandler.on(window, 'resize', this.resizeHandler)
    },
    // 取消事件绑定
    unbindResizeEvent () {
      // 取消绑定resize事件
      // eventHandler.off(window, 'resize', this.resizeHandler)
    },

    /**
         * @description 销毁图表
         * @name destroyedChart
         * @return {*} 无
         */
    destroyedChart () {
      // 如果存在echarts
      if (this.myEchart) {
        // 销毁实例，销毁后实例无法再被使用。
        this.myEchart.dispose()
        this.myEchart = null
        // 取消事件绑定
        this.unbindResizeEvent()
      }
    }
  }
}
